export const CURRENT_TOAST_ADD = "CURRENT_TOAST_ADD"; 
export const CURRENT_TOAST_CLEAR = "CURRENT_TOAST_CLEAR";